/**
 * 云pos api请求
 */

import axios from 'axios'
import {
    localToken,
    cache,
    toolFunc
} from '@/libs/func';
import globConfig from '@/config/config';

// import { Spin } from 'iview'
class HttpRequest {
    constructor(baseUrl = baseURL) {
        this.baseUrl = baseUrl;
        this.queue = {}
    }

    getInsideConfig() {
        return {
            baseURL: this.baseUrl,
            headers: {
                //
            }
        };
    }

    distroy(url) {
        delete this.queue[url];
        if (!Object.keys(this.queue).length) {
            // Spin.hide()
        }
    }

    interceptors(instance, url) {
        // 请求拦截
        instance.interceptors.request.use(config => {
            // 添加全局的loading...
            if (!Object.keys(this.queue).length) {
                // Spin.show() // 不建议开启，因为界面不友好
            }
            this.queue[url] = true;

            //是否无需access_token 的方法 start
            let whiteMethod = false;
            let whiteMethodList = globConfig.apiWhite || [];
            for (let i = 0; i < whiteMethodList.length; i++) {
                if (url.indexOf(whiteMethodList[i]) > -1) {
                    whiteMethod = true;
                    break;
                }
            }

            let anonymousApi = false;
            let anonymousApiList = globConfig.anonymousApi || [];
            for (let i = 0; i < anonymousApiList.length; i++) {
                if (url.indexOf(anonymousApiList[i]) > -1) {
                    anonymousApi = true;
                    break;
                }
            }

            console.log('whiteMethod', whiteMethod);
            if (whiteMethod) { //白名单方法 无需access_token
                if (url.indexOf('/wap/User/login') > -1) { //特殊api 登录
                    // if (url.indexOf('/wap/User/debuglogin') > -1) { //特殊api 登录
                    let tempToken = cache.get(globConfig.loginTokenName);
                    if (!tempToken) {
                        //window.location.href = '/Oauth';
                        toolFunc.jumpToDn('/Oauth');
                        return;
                    }
                    //使用完成清除登录token
                    cache.set(globConfig.loginTokenName, null);
                    config.headers.Authorization = tempToken;

                }
                // else if (url.indexOf('/ErrorPage/Error') > -1) { //特殊api 登录
                // let tempToken = cache.get(globConfig.loginTokenName);
                // if (!tempToken) {
                //     window.location.href = '/Oauth';
                //     return;
                // }
                // //使用完成清除登录token
                // cache.set(globConfig.loginTokenName, null);
                // config.headers.Authorization = tempToken;
                // }
                else if (url.indexOf('/wap/User/signup') > -1) { //特殊api 注册
                    let tempToken = cache.get(globConfig.registerTokenName);
                    if (!tempToken) {
                        //window.location.href = '/Oauth';
                        toolFunc.jumpToDn('/Oauth');
                        return;
                    }
                    //使用完成后清除注册token
                    cache.set(globConfig.registerTokenName, null);
                    config.headers.Authorization = tempToken;

                } else {
                    config.headers.Authorization = "";
                }

            } else if (anonymousApi) { //可以不绑定手机号的访问(但是需要正常业务token)

                let tempToken = cache.get(globConfig.anonymousTokenName);
                if (!tempToken) {
                    //window.location.href = '/Oauth';
                    toolFunc.jumpToDn('/Oauth');
                    return;
                }
                //这里不能清除正常业务token 虽然不是存在同一个地方，但是其他地方可能用到
                //cache.set(globConfig.registerTokenName, null);
                config.headers.Authorization = tempToken;

            } else {

                //获取本地存放的token
                let access_token = localToken.get();
                if (!access_token) { //token有问题
                    // localToken.set('');
                    localToken.clearLocal();
                    //这里需要跳转到 微信重新授权 (此处的处理方式 需要注意 如何让用户无感知完成token刷新)
                    //window.location.href = '/Oauth';
                    toolFunc.jumpToDn('/Oauth');
                    return;
                    //return Promise.reject('登录状态无效，请重新登录');
                }

                config.headers.Authorization = access_token;
            }
            //无需Authorization的接口 去除Authorization字段
            if (!config.headers.Authorization) {
                delete config.headers.Authorization;
            }

            //是否无需access_token 的方法 end

            return config

        }, error => {
            return Promise.reject(error)
        });

        // 响应拦截
        instance.interceptors.response.use(res => {
            console.log(res, '响应数据');
            this.distroy(url);
            let data = res.data;

            /*  if(url.indexOf(globConfig.tokenGetMethod) > -1) { //登录接口
                  if(typeof data.status !== 'undefined' && data.status === true) {
                      let {token_type, access_token, expires_in, status} = data;
                      localToken.set(token_type + ' ' + access_token, expires_in);
                      return {data: {token_type, token : access_token, expires_in, status }};
                  }

              } else {*/
            // 测试
            // if (url.indexOf('/wap/Account/newsms') > -1) {
            //     return res
            // } else
            if (true === data.success && null === data.error) {
                //返回正确的内容就返回纯数据
                console.log('api正确返回数据', res.data.value);
                return res.data.value || [];
                //return val;
            } else {
                //没有返回正确的内容 直接走error
                console.log('来这里了');
                return Promise.reject(data.error);
                /*return Promise.reject(data.error).catch(err => {
                    console.log('没有返回的err', err);
                });*/
            }

            //  }
        }, error => {
            this.distroy(url);
            return Promise.reject(error)
        })
    }

    //通用请求
    request(options) {
        const instance = axios.create();
        options = Object.assign(this.getInsideConfig(), options);
        this.interceptors(instance, options.url);
        return instance(options)
    }

    //增加几种常用方式
    get(options) {
        options = Object.assign({
            method: 'get'
        }, options);
        return this.request(options);
    }

    post(options) {
        options = Object.assign({
            method: 'post'
        }, options);
        return this.request(options);
    }

    put(options) {
        options = Object.assign({
            method: 'put'
        }, options);
        return this.request(options);
    }

    del(options) {
        options = Object.assign({
            method: 'delete'
        }, options);
        return this.request(options);
    }

    path(options) {
        options = Object.assign({
            method: 'path'
        }, options);
        return this.request(options);
    }

    parseParams(data) {
        try {
            let tempArr = [];
            for (let i in data) {
                let key = encodeURIComponent(i);
                let value = encodeURIComponent(data[i]);
                tempArr.push(key + '=' + value);
            }
            return tempArr.join('&');

        } catch (err) {
            return '';
        }
    }

}

export default HttpRequest


// WEBPACK FOOTER //
// ./src/libs/api.axios.js